<template>
  <el-container>
    <el-main>
      欢迎回来，{{ userInfo.name }}
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      userInfo: {
        name: ''
      }
    }
  },
  mounted () {
    this.userInfo.name = localStorage.getItem('admin')
  }
}
</script>

<style scoped>
</style>
